import { render, staticRenderFns } from "./task-copy.vue?vue&type=template&id=79b5d81c&"
import script from "./task-copy.vue?vue&type=script&lang=js&"
export * from "./task-copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b5d81c')) {
      api.createRecord('79b5d81c', component.options)
    } else {
      api.reload('79b5d81c', component.options)
    }
    module.hot.accept("./task-copy.vue?vue&type=template&id=79b5d81c&", function () {
      api.rerender('79b5d81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-copy.vue"
export default component.exports